import script from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=0f2ad9d1&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2ad9d1"]])

export default __exports__